import styled from 'styled-components';

const BackgroundBlobs = ({ zIndex }: { zIndex?: number }) => {
  return (
    <BackgroundContainer $zIndex={zIndex}>
      <BackgroundBlob />
      <BackgroundBlob $blobNumber={1} />
      <BackgroundBlob $blobNumber={2} />
      <BackgroundBlob $blobNumber={3} />
      <BackgroundBlob $blobNumber={4} />
    </BackgroundContainer>
  );
};

export default BackgroundBlobs;

const BackgroundContainer = styled.div<{ $zIndex?: number }>`
  height: 100%;
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  position: absolute;
  top: 0;
  left: 0;
  ${({ $zIndex }) => $zIndex !== undefined && `z-index: ${$zIndex}`};
`;

export const BackgroundBlob = styled.div<{ $blobNumber?: number }>`
  background: #fce7d6;
  position: absolute;

  ${({ $blobNumber }) =>
    $blobNumber === 1
      ? `height: 240px;
	width: 250px;
	left: 10%;
	top: 20%;
	transform: rotate(-180deg);
	animation: shape_shift 10s ease-in-out infinite both alternate, blob_three 65s cubic-bezier(0.42, 0, 0.58, 1) infinite both;`
      : $blobNumber === 2
      ? `height: 220px;
	width: 210px;
	left: -20%;
	top: 20%;
	transform: rotate(-180deg);
	animation: shape_shift 5s ease-in-out infinite both alternate, blob_two 70s cubic-bezier(0.42, 0, 0.58, 1) infinite both;`
      : $blobNumber === 3
      ? `height: 150px;
width: 155px;
left: 5%;
top: 60%;
transform: rotate(90deg);
animation: shape_shift 5s ease-in-out infinite both alternate, blob_three 55s cubic-bezier(0.42, 0, 0.58, 1) infinite both;`
      : $blobNumber === 4
      ? `height: 300px;
  width: 290px;
  left: 100%;
  top: calc(0% + 300px);
  transform: rotate(-90deg);
  animation: shape_shift 8s ease-in-out infinite both alternate, blob_four 50s cubic-bezier(0.42, 0, 0.58, 1) infinite both;`
      : `height: 210px;
  width: 205px;
  border-radius: 30% 50% 20% 40%;
  animation: shape_shift 9s ease-in-out infinite both alternate,
    blob_one 60s cubic-bezier(0.42, 0, 0.58, 1) infinite both;
  left: 70%;
  top: calc(100% - 250px);`}

  @keyframes shape_shift {
    0%,
    100% {
      border-radius: 33% 67% 70% 30% / 30% 30% 70% 70%;
    }
    20% {
      border-radius: 37% 63% 51% 49% / 37% 65% 35% 63%;
    }
    40% {
      border-radius: 36% 64% 64% 36% / 64% 48% 52% 36%;
    }
    60% {
      border-radius: 37% 63% 51% 49% / 30% 30% 70% 70%;
    }
    80% {
      border-radius: 40% 60% 42% 58% / 41% 51% 49% 59%;
    }
  }

  @keyframes blob_one {
    0%,
    100% {
      transform: none;
    }
    50% {
      transform: translate(-400%, -30%) rotateY(10deg) scale(1.3);
    }
  }
  @keyframes blob_two {
    0%,
    500% {
      transform: none;
    }
    50% {
      transform: translate(200%, 60%) rotate(-200deg) scale(1.2);
    }
  }

  @keyframes blob_three {
    0%,
    500% {
      transform: none;
    }
    50% {
      transform: translate(280%, 20%) rotate(-100deg) scale(0.9);
    }
  }

  @keyframes blob_four {
    0%,
    500% {
      transform: none;
    }
    50% {
      transform: translate(-200%, 40%) rotate(180deg) scale(1.1);
    }
  }
`;
